module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-29.e0a69e26.png";